<template>
  <div class="welcome-banner">
    <div>
      <strong>Welcome to Zight!</strong> Create videos, screenshots and share.
    </div>
    <a class="btn btn-large download-button" href="https://share.getcloudapp.com/download?utm_source=viewer&utm_campaignn=siws_viewer_banner">
      <i class="fa fa-download"></i> Download Zight for free
    </a>
  </div>
</template>

<script>
export default {
  name: "WelcomeBanner",
};
</script>

<style scoped lang="scss">

.welcome-banner {
  display: flex;
  padding: .7rem;
  border: solid 1px lightgray;
  margin: 0 4vh 10px 4vh;
  border-radius: 10px;
  justify-content: center;
  align-items: center;

  .download-button {
    background-image: linear-gradient(113deg, #f09819 12%, #ff5858 96%);
    border-radius: 4px;
    border-top: linear-gradient(113deg, #f09819 12%, #ff5858 96%);
    border-bottom: linear-gradient(113deg, #f09819 12%, #ff5858 96%);
    border-left: none;
    border-right: none;
    color: white;
    font-family: SFPro;
    font-size: 0.75rem;
    height: 36px;
    margin: 0 0 0 1rem;
    padding: 0.5rem;
    text-decoration: none;
  }
}
</style>
